module.exports = __webpack_public_path__ + "img/MONITOR1.12f1bd38.gif";